import React from "react";
import { Sparkles } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="container-editorial py-24 min-h-[70vh] flex items-center" data-testid="page-login">
      <div className="max-w-md mx-auto text-center">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-viola text-cream">
          <Sparkles size={22} />
        </div>
        <h1 className="mt-6 font-display text-4xl">Area riservata</h1>
        <p className="mt-3 text-viola/75">L'accesso al pannello amministrazione è protetto. Accedi con il tuo account Google autorizzato.</p>
        <button onClick={handleLogin} className="mt-8 btn-primary" data-testid="login-google">Accedi con Google</button>
      </div>
    </div>
  );
}
